 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXT9780310340454_COVER from '@/components/text/9780310340454_Cover'
 import TEXT9780310340454_PRAISE from '@/components/text/9780310340454_Praise'
 import TEXT9780310340454_TITLEPAGE from '@/components/text/9780310340454_Titlepage'
 import TEXT9780310340454_COPYRIGHT from '@/components/text/9780310340454_Copyright'
 import TEXT9780310340454_DISCLAIMER from '@/components/text/9780310340454_Disclaimer'
 import TEXT9780310340454_DEDICATION from '@/components/text/9780310340454_Dedication'
 import TEXTNAV from '@/components/text/nav'
 import TEXT9780310340454_FOREWORD from '@/components/text/9780310340454_Foreword'
 import TEXT9780310340454_INTRODUCTION from '@/components/text/9780310340454_Introduction'
 import TEXT9780310340454_CHAPTER_1 from '@/components/text/9780310340454_Chapter_1'
 import TEXT9780310340454_CHAPTER_2 from '@/components/text/9780310340454_Chapter_2'
 import TEXT9780310340454_CHAPTER_3 from '@/components/text/9780310340454_Chapter_3'
 import TEXT9780310340454_CHAPTER_4 from '@/components/text/9780310340454_Chapter_4'
 import TEXT9780310340454_CHAPTER_5 from '@/components/text/9780310340454_Chapter_5'
 import TEXT9780310340454_CHAPTER_6 from '@/components/text/9780310340454_Chapter_6'
 import TEXT9780310340454_CHAPTER_7 from '@/components/text/9780310340454_Chapter_7'
 import TEXT9780310340454_CHAPTER_8 from '@/components/text/9780310340454_Chapter_8'
 import TEXT9780310340454_CHAPTER_9 from '@/components/text/9780310340454_Chapter_9'
 import TEXT9780310340454_CHAPTER_10 from '@/components/text/9780310340454_Chapter_10'
 import TEXT9780310340454_CONCLUSION from '@/components/text/9780310340454_Conclusion'
 import TEXT9780310340454_ACKNOWLEDGMENTS from '@/components/text/9780310340454_Acknowledgments'
 import TEXT9780310340454_NOTES from '@/components/text/9780310340454_Notes'
 import TEXT9780310340454_STARRY_EYED from '@/components/text/9780310340454_Starry_Eyed'
 import TEXT9780310340454_ABOUT_MOPS_INTERNATIONAL from '@/components/text/9780310340454_About_MOPS_International'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/text/nav",
 			"name" : "text/nav",
 			"component" : TEXTNAV
 		},
 		{
 			"path" : "/text/9780310340454_Foreword",
 			"name" : "text/9780310340454_Foreword",
 			"component" : TEXT9780310340454_FOREWORD
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js